// react
import { ReactNode, useContext } from 'react';

// router
import { Link as RouterLink } from 'react-router-dom';

// types
import { Ifr, Project } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// mui
import { Link, LinkProps, Typography } from '@mui/material';

// props
export interface LinkIfrProps extends LinkProps {
	children?: ReactNode;
	ifr: Ifr;
	project?: Project;
	[x: string]: unknown;
}

export const LinkIfr = ({ children, ifr, project, ...props }: LinkIfrProps) => {
	// context
	const { project: projectContext } = useContext(ContextProject);

	// hooks
	const { t } = useTranslation();

	// vars
	const projectId = project ? project.idWbg : projectContext?.idWbg;

	let link = <Typography>{t('na')}</Typography>;

	if (ifr) {
		if (ifr.id && projectId && (children || ifr.name)) {
			link = (
				<Link
					component={RouterLink}
					fontWeight={600}
					sx={{ wordBreak: 'break-word' }}
					to={`/project/${projectId}/ifr/${ifr.id}`}
					underline="hover"
					{...props}>
					{children || ifr.name}
				</Link>
			);
		} else if (ifr.name) {
			link = <Typography fontWeight={500}>{ifr.name}</Typography>;
		}
	}

	return link;
};
